import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTimesheetApprovalsPage } from './cabsand-timesheet-approvals';

@NgModule({
  declarations: [
    CabsandTimesheetApprovalsPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTimesheetApprovalsPage),
  ],
})
export class CabsandTimesheetApprovalsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-approvals/cabsand-timesheet-approvals.module.ts